import React from 'react'
import { Modal } from 'react-bootstrap'
import IconFawry from 'assets/images/svg/fawry_full.svg'
import { Link } from "react-router-dom";
import { json } from 'helpers/data';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

const FawrySummary = ({ show, onHide,data,number,expire, ...props }) => {
    const { t } = useTranslation("browse-apps");

    return (
        <div className=''>
            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={show}
                onHide={onHide}
                className='all-modal fawry'
            >
                <Modal.Body>
                    <div className='header'>

                    </div>
                    <div className='row'>
                        <div className='col-md-12'>
                            <img className='fawryIcon' src={IconFawry} alt="fawry" />
                            <h1 className='title'>{t("paymentDetails.fawryPaySummery.ordernumber")}: {number}</h1>
                            <p className='order-info'>{t("paymentDetails.fawryPaySummery.orderInfo")} {moment(expire).format('DD/MM/YYYY')}</p>
                            <p className='pay'> {t("paymentDetails.fawryPaySummery.wherePay")}, <Link to="/invoices/unpaid">{t("paymentDetails.fawryPaySummery.clickHere")}</Link></p>
                            <div className='box-product-info'>
                                <p> {t("paymentDetails.fawryPaySummery.product")}: <span>{json(data?.versionTitle)} / {data?.numberOfLicenses} {t("paymentDetails.summary.users")}</span></p>
                                <p> {t("paymentDetails.fawryPaySummery.unitPrice")}:<span>{data?.subTotal} {json(data?.currencyName)}</span></p>
                                <p> {t("paymentDetails.fawryPaySummery.total")}:<span>{data?.total} {json(data?.currencyName)}</span></p>

                            </div>
                        </div>


                        <div className='col-12'>
                            <button className='btn-blue' onClick={onHide}>{t("paymentDetails.paymentMessage.close")}</button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            </div>
    )
}

export default FawrySummary